import React from "react";
import "./NailServiceCard.css";
import "../../MainServicePages/ServiceCards/ServiceCards.css";
import ServiceCards from "../../MainServicePages/ServiceCards/ServiceCards";
const NailServiceCardContain = () => {
  return (
    <div className="nailCardContainer">
      <ServiceCards
        heading="Nail Extensions"
        para="Refine and sculpt your nails with our meticulously crafted extensions, expertly designed to enhance the beauty of your nails using professional techniques and precision."
        goto="Nail Extensions"
        img="https://img.freepik.com/free-photo/woman-using-digital-nail-file_23-2148766613.jpg?t=st=1714634029~exp=1714637629~hmac=17de968d9d51b35eded6820b4eb257a439eebaf67afb7172e23cfd322166864b&w=900"
        link="/nails-extension"
      />
      <ServiceCards
        heading="Gel Nail Art"
        para="Transform your nails into works of art with stunning designs meticulously crafted by our in-house experts, elevating nail painting into a true form of creativity."
        goto="Gel Nail Art"
        img="https://img.freepik.com/free-photo/close-up-hands-with-beautiful-manicure_23-2149311588.jpg?t=st=1714633822~exp=1714637422~hmac=3575220a19320fd8dd25f82dff63eded6f9f2a6f72eaf6499ad4a28da68417f7&w=360"
        link="/gel-nail-art"
      />
      <ServiceCards
        heading="Chrome Gel Polish"
        para="Immerse yourself in the allure of a stunning chrome finish expertly applied by our skilled nail technicians, transforming your nails into works of art."
        goto="Chrome Gel Polish"
        img="https://img.freepik.com/free-photo/stylish-trendy-female-silver-manicure_186202-5566.jpg?t=st=1714633866~exp=1714637466~hmac=d4a2fc44c9d1f1fdee4d67f3ad46a06a457d8011cb4eaa7649eecae674efb98a&w=826"
        link="/chrome-gel-nail-polish"
      />
      <ServiceCards
        heading="Ombre Gel Polish"
        para="Embrace the trendy ombre nail aesthetic, where two or more harmonizing colors seamlessly blend, creating a captivating gradient effect that's both chic and stylish."
        goto="Ombre Gel Polish"
        img="https://img.freepik.com/free-photo/beautiful-nail-art-presentation_23-2149295367.jpg?t=st=1714633960~exp=1714637560~hmac=cb6d8e2485e8203db2b050b867fa3bdce485c83a94aec20c88e29c3df14d8aab&w=360"
        link="/ombre-gel-nail-polish"
      />
      <ServiceCards
        heading="Classic Manicure"
        para="Treat yourself to our Classic Manicure for perfectly groomed nails. Our skilled technicians will shape, buff, and polish your nails to perfection, leaving your hands looking and feeling revitalized."
        goto="Classic Manicure"
        img="https://img.freepik.com/free-photo/carefree-young-woman-with-party-makeup-expressing-happiness-inspired-brunette-girl-laughing-dark-wall_197531-14013.jpg?t=st=1714632051~exp=1714635651~hmac=6b5297f358a7454784f6c04c74476ff6b112275f46ab480eb7f88a616617d9d2&w=900"
        link="/classic-manicure"
      />
      <ServiceCards
        heading="Organic Manicure"
        para="Experience ultimate pampering with our Organic Manicure. Our skilled technicians use natural products to nourish and beautify your nails and cuticles."
        goto="Organic Maincure"
        img="https://img.freepik.com/free-photo/close-up-nail-care-treatment_23-2149262899.jpg?t=st=1714632077~exp=1714635677~hmac=19785bd7df5bd245579b0f35dda4b9aa9f04efc4a8c1999df24b1dcc29fbce83&w=360"
        link="/organic-manicure"
      />
      <ServiceCards
        heading="Classic Pedicure"
        para="
        Treat your feet with our Classic Pedicure. Enjoy a soothing soak, nail shaping, cuticle care, and a moisturizing massage. Leave feeling refreshed and rejuvenated."
        goto="Classic Pedicure"
        img="https://img.freepik.com/premium-photo/closeup-photo-beautiful-female-foot-with-pedicure-hands-with-manicure_488220-13300.jpg?w=360"
        link="/classic-pedicure"
      />
      <ServiceCards
        heading="Organic Pedicure"
        para="
        Indulge in our Organic Pedicure with natural products. Enjoy a foot soak, exfoliation, nail shaping, and cuticle care. Leave feeling refreshed and pampered."
        goto="Organic Pedicure"
        img="https://img.freepik.com/free-photo/pedicurist-master-makes-pedicure-woman-s-legs-spa-treatment-concept_186202-7773.jpg?t=st=1714630388~exp=1714633988~hmac=640a1d0aea95f3965395d2446f018b13f9c97ae39561f635596843cb3bdb97d3&w=826"
        link="/organic-pedicure"
      />
      <ServiceCards
        heading="Candle Spa Manicure"
        para="
        Try our Candle Spa Manicure for luxurious nail care. Enjoy a warm wax treatment, nail shaping, cuticle care, and a hydrating massage for soft, tranquil hands."
        goto="Candle Spa Manicure"
        img="https://img.freepik.com/premium-photo/closeup-beautiful-woman-hands-getting-manicure-spa-salon_141188-4310.jpg?w=900"
        link="/candle-spa-manicure"
      />
      <ServiceCards
        heading="Candle Spa Pedicure"
        para="
        Experience our Candle Spa Pedicure: luxurious and relaxing. Enjoy a warm candle wax treatment, nail shaping, cuticle care, and a hydrating massage. Leave feeling rejuvenated from heel to toe."
        goto="Candle Spa Pedicure"
        img="https://img.freepik.com/premium-photo/beautician-waxing-female-legs-spa-center_118454-17518.jpg?w=900"
        link="/candle-spa-pedicure"
      />
      <ServiceCards
        heading="Cut & File"
        para="Get your nails in perfect shape with our Cut & File service. Our skilled technicians will expertly trim and shape your nails to your desired length and style, leaving them looking neat and polishe"
        goto="Cut & File"
        img="https://img.freepik.com/free-photo/nail-care-manicure-process_23-2149130306.jpg?t=st=1714632984~exp=1714636584~hmac=6a64c7fa5c62e01f7853ceae83e4c9ef92f6cedd251aa13c42d23b28c6fc7b13&w=900"
        link="/nail-cut-and-file"
      />
      <ServiceCards
        heading="Colour Change"
        para="
        Transform your look instantly with our Colour Change service. Choose from a wide range of vibrant shades and let our skilled technicians give your nails a rejuvenating and stylish makeover."
        goto="Colour Change"
        img="https://img.freepik.com/free-photo/woman-receiving-manicure-from-woman-gloves-mask-beauty-salon-daytime_176474-2912.jpg?t=st=1714633073~exp=1714636673~hmac=397ae9e5c42240a86483bf71ade2e14cb93ac1d98b3cb98f78e0b328809941b8&w=996"
        link="/nail-color-change"
      />
      <ServiceCards
        heading="Geleration"
        para="
        Get chip-free, long-lasting nails with our Geleration service. Our skilled technicians apply a durable gel polish that dries instantly under UV light, ensuring beautiful nails for weeks."
        goto="Geleration"
        img="https://img.freepik.com/premium-photo/woman-is-getting-manicure-beauty-salon_199620-2475.jpg?w=900"
        link="/nail-geleration"
      />
      <ServiceCards
        heading="French Geleration"
        para="Elevate your elegance with our French Geleration service. Our skilled technicians apply durable gel polish for sophisticated nails that last weeks."
        goto="French Geleration"
        img="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgjD0UWrlikaDJkyZYyol0T9eOTwvrKyGwDDQlRm_ayrgM28E-eL6-Ax4zHLADyJetJZVPFTHGOEbDrMspukYT2kefAUxgX5z6gUM2ja7HdeR88x5Z5qeroR0U4dl4a6jKQY1YFeSoXWZ4q/s1600/DSCF1076.JPG"
        link="/french-nail-geleration"
      />
      <ServiceCards
        heading="Nail Extension Infill"
        para="Refresh your nail extensions with our Infill service. Our experts fill gaps, reshape, and maintain your nails' natural appearance, ensuring lasting flawlessness."
        goto="Nail Extension Infill"
        img="https://img.freepik.com/free-photo/beautiful-woman-hands-top-view_23-2148766607.jpg?t=st=1714634153~exp=1714637753~hmac=c4e46f826b33c3b31f673ba410d1be46321ca518488f70ec8ad147ccc93654e1&w=740"
        link="/nails-extension-infill"
      />
    </div>
  );
};

export default NailServiceCardContain;
